// extracted by mini-css-extract-plugin
export default {"options":"SocialOptions_options__C9j8o"};